/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import { App } from "./App";

// Clerk publishable key - inlined at build time via bunfig.toml env = "PUBLIC_*"
// Set PUBLIC_CLERK_PUBLISHABLE_KEY in your .env file or environment
// Get yours at: https://dashboard.clerk.com/last-active?path=api-keys
//
// Bun replaces process.env.PUBLIC_* with literal values at build time.
// If the env var is not set, this will be replaced with `undefined`.
const PUBLISHABLE_KEY = process.env.PUBLIC_CLERK_PUBLISHABLE_KEY || "pk_test_missing_key";

if (!process.env.PUBLIC_CLERK_PUBLISHABLE_KEY) {
  console.warn(
    "Missing PUBLIC_CLERK_PUBLISHABLE_KEY environment variable. " +
    "Auth features will not work. Add it to your .env file."
  );
}

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
      <App />
    </ClerkProvider>
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
